import gql from 'graphql-tag'

export default gql`mutation createUser($data: UserInput!){
  createUser(user: $data){
    user_id
  }
}`